var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItservices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1431 40.0715C74.1431 49.1079 70.5534 57.7741 64.1637 64.1637C57.7741 70.5534 49.1079 74.1431 40.0715 74.1431C31.0352 74.1431 22.369 70.5534 15.9793 64.1637C9.58967 57.7741 6 49.1079 6 40.0715M74.1431 40.0715C74.1431 31.0352 70.5534 22.369 64.1637 15.9793C57.7741 9.58967 49.1079 6 40.0715 6C31.0352 6 22.369 9.58967 15.9793 15.9793C9.58967 22.369 6 31.0352 6 40.0715M74.1431 40.0715H6",
    stroke: "white",
    strokeWidth: 5.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1776 40.0715C52.5339 52.5312 47.9446 64.4633 40.0732 74.1431C32.2017 64.4633 27.6124 52.5312 26.9688 40.0715C27.6124 27.6119 32.2017 15.6797 40.0732 6C47.9446 15.6797 52.5339 27.6119 53.1776 40.0715Z",
    stroke: "white",
    strokeWidth: 5.21,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItservices);
export default __webpack_public_path__ + "static/media/itservices.e67b28be384393174b6ad3d5a736d1a7.svg";
export { ForwardRef as ReactComponent };